/**
 * Alert <uo-tab>
 *
 * Attributes:
 * id        The ID of the tab. This is used to get the tab panel.
 * active    Defines whether the tab is active or not
 * disabled  Defines whether the tab is disabled or not
 * loading   Defines whether the tab is loading or not
 * direction Row or column, as with flex
 * status    "warning", "error", "success"
 * href      Link the tab should go to, if the content is not loaded
 */

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';

// Import style for web component
const styles = require( './web-component-style.scss' );

// eslint-disable-next-line require-jsdoc
export class AutomatorTab extends LitElement {
    // Define style
    static styles = css`${ unsafeCSS( styles ) }`;

    // eslint-disable-next-line require-jsdoc
    static properties = {
        id: { type: String },
        direction: { type: String },
        status: { type: String },
        href: { type: String },
        active: { type: Boolean },
        disabled: { type: Boolean },
        loading: { type: Boolean },
    };

    // eslint-disable-next-line require-jsdoc
    constructor() {
        super();
    }

    // eslint-disable-next-line require-jsdoc
    render() {
        return html`
            <div 
                class="tab"

                status=${ ifDefined( this.status ) }
                direction=${ ifDefined( this.direction ) }

                ?active=${ this.active }
                ?disabled=${ this.disabled }
                ?loading=${ this.loading }
            >
                <a>
                    <slot></slot>
                </a>
            </div>
        `;
    }
}

customElements.define( 'uo-tab', AutomatorTab );
